module.exports = __webpack_public_path__ + "static/media/30.9a92ad5e.png";